/**
 * Top-level storefront sections. Each site maps them to its own root ids through site preferences
 * (catalog category for `onlineShop`/`events`/`courses`, content folder for `restaurants`), so ids
 * can be localized per site and must never be hard-coded.
 */
export const NAVIGATION_PILLARS = ['onlineShop', 'events', 'courses', 'restaurants'] as const;

export type NavigationPillar = (typeof NAVIGATION_PILLARS)[number];

export type NavigationPillarRootIds = Partial<Record<NavigationPillar, string>>;

export function isNavigationPillar(value: unknown): value is NavigationPillar {
    return (NAVIGATION_PILLARS as readonly unknown[]).includes(value);
}

/** Pillar whose configured root category/folder id is `rootId`. */
export function findNavigationPillar(
    rootIds: NavigationPillarRootIds,
    rootId: string | null | undefined
): NavigationPillar | undefined {
    if (!rootId) {
        return undefined;
    }
    return NAVIGATION_PILLARS.find((pillar) => rootIds[pillar] === rootId);
}
